export const DEFAULT_SELECT_LIST_LIMIT = 30
export const AUTH_TOKEN = 'x-auth-token'

export const SIDE_NAV_COLLAPSED_WIDTH = 72
export const HEADER_HEIGHT = 72

export const DATE_FORMAT = 'DD.MM.YYYY'

export const STRING_DATE_FORMAT = 'yyyy-MM-dd'
